import { Attention } from "components/icons/components";
import ROUTING, { EDDM_ROUTING } from "config/routing";
import { generatePath, useHistory } from "react-router";
import { useParams } from "react-router-dom";

interface UploadFlyerSectionProps {
  isDM: boolean;
}

export const UploadFlyerSection = ({ isDM }: UploadFlyerSectionProps) => {
  const history = useHistory();
  const { campaignId, clientId } = useParams();

  const handleClick = (campaignId: string, clientId: number) => {
    if (isDM) {
      history.push(generatePath(EDDM_ROUTING.EDDM_UPLOAD_FLYER, { campaignId, clientId }));
    } else {
      const existSkipDesignCampaigns = localStorage.getItem("skipDesignCampaigns");
      const skipCampaign = {
        wasRedirected: true,
        campaignId,
      };

      if (existSkipDesignCampaigns) {
        const parsed = JSON.parse(existSkipDesignCampaigns);
        const alreadyExisting = parsed.find(
          (campaign: { campaignId: string; wasRedirected: boolean }) => campaign.campaignId === campaignId
        );
        if (!alreadyExisting) {
          localStorage.setItem("skipDesignCampaigns", JSON.stringify([...parsed, skipCampaign]));
        }
      } else {
        localStorage.setItem("skipDesignCampaigns", JSON.stringify([skipCampaign]));
      }

      const path = generatePath(ROUTING.FLYER, { campaignId, clientId });
      history.push(path);
    }
  };

  return (
    <div className="mb-[60px] mt-2.5 flex min-h-[92px] w-full items-center rounded-lg bg-[#ffe7eb] px-5 py-4 dark:bg-destructive/15 max-[450px]:h-[150px]">
      <div className="flex w-full flex-col max-[450px]:relative">
        <div className="flex h-[35px] w-full items-center justify-between">
          <div className="flex h-full w-full items-center text-destructive max-[450px]:absolute max-[450px]:top-[-50px]">
            <Attention stroke="currentColor" />
            <p className="ml-[5px] text-sm font-semibold text-destructive">Flyer design needed</p>
          </div>
          <button
            data-cy="reviewUploadDesignButton"
            onClick={() => handleClick(campaignId, clientId)}
            className="h-[30px] w-[150px] cursor-pointer rounded-lg border border-solid border-primary bg-transparent text-center text-[13px] font-bold text-primary max-[450px]:absolute max-[450px]:bottom-[-40px]"
          >
            Upload design
          </button>
        </div>
        <p className="max-w-[75%] text-[13px] text-foreground max-[450px]:absolute max-[450px]:top-[-10px] max-[450px]:max-w-full">
          Please upload your flyer design before scheduling your campaign.
        </p>
      </div>
    </div>
  );
};
